import React, { useEffect, useState, useCallback } from 'react'
import { Link } from 'react-router-dom'
import Icons from '../../myIcon/Icons';
import { Helmet } from 'react-helmet-async';

export default function ComingSoon() {
  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = useCallback(() => {
    const heightFromTop = window.scrollY;
    setIsSticky(heightFromTop > 0);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="comingsoon-area">
        <div className={`coming-header ${isSticky ? 'stick' : ''}`}>
          <div className='container'>
            <div className='row align-items-center'>
              <div className='col-lg-6 col-md-6 col-4'>
                <Link to={"/"} className='coming-logo'>
                  <img
                    src={isSticky ? '/image/logo.webp' : '/image/logo-white.webp'}
                    alt='header-logo'
                  />
                </Link>

              </div>
              <div className='col-lg-6 col-md-6 col-8'>
                <ul className="footer-social">
                  <li><Link to="https://www.facebook.com/ResortDeCoracaoofficial/" target="_blank" aria-label="Facebook"><Icons name="facebook" /></Link></li>
                  <li><Link to="https://www.instagram.com/resortdecoracao/" target="_blank" aria-label="instagram"><Icons name="instagram" /></Link></li>
                  <li><Link to="https://www.linkedin.com/company/resort-de-coração" target="_blank" aria-label="linkedin"><Icons name="linkedin" /></Link></li>
                  <li><Link to="https://web.whatsapp.com/send?phone=+919292928787&_ga=2.261651789.1393896926.1665567039-1858394251.1662704687" target="_blank" aria-label="whatsapp"><Icons name="whatsapp" /></Link></li>
                  <li><Link to="https://www.youtube.com/channel/UCjgc3pXH7KYjPdsDCKnD_vw" target="_blank" aria-label="youtube"><Icons name="youtube" /></Link></li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <div className='coming-about'>
          <div className='container'>
            <div className='row justify-content-center'>
              <div className='col-lg-6 col-md-8'>
                <h1 className='heading'>
                  Booking Open Now
                </h1>
                <p>Experience refined comfort at De coracao Rishikesh — a premium resort and hotel where luxury meets serene nature, coming soon.</p>
                <div className='coming-buttons'>
                  <Link to={"/"} className="default-btn color-btn">GO TO HOME PAGE</Link>
                  <Link to="/contact-us" className="default-btn">Contact us</Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='explore-properties'>
          <div className='container'>
            <div className='row justify-content-center'>
              <div className='col-lg-12 '>
                <h2 className='heading'>explore our other properties</h2>
              </div>

              <div className='col-lg-4 col-md-5 col-sm-6'>
                <Link to={"/resort-de-coracao-goa"} className='commingexplore-card'>
                  <div>
                    <img src='/image/coming-card-1.webp' alt='Goa' className='img-responsive' />
                    <img src='/image/banner-mobile-1.webp' alt='Goa' className='img-responsive' />
                  </div>
                  <h3>Goa</h3>
                </Link>
              </div>

              <div className='col-lg-4 col-md-5 col-sm-6'>
                <Link to={"/resort-de-coracao-corbett"} className='commingexplore-card'>
                  <div>
                    <img src='/image/coming-card-2.webp' alt='Jim Corbett' className='img-responsive' />
                    <img src='/image/banner-mobile-2.webp' alt='Jim Corbett' className='img-responsive' />
                  </div>
                  <h3>Jim Corbett</h3>
                </Link>
              </div>

            </div>
          </div>
        </div>

        <div className='coming-footer'>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <div className='coming-footer-wrap'>
                  <a href="mailto:reservation@resortdecoracao.com">
                    <img src="/image/coming-email.webp" alt="email" />reservation@resortdecoracao.com</a>

                  <a href="tel:+91 9292928787">
                    <img src="/image/coming-phone.webp" alt="phone" />+91 929292 8787</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
